import { useQuery } from 'react-query';
import { getPublicProfile } from 'resources/company/company.api';

export default function useGetPublicProfile(companyId, queryOptions) {

  return useQuery(['company.getPublicProfile', companyId],
    () => getPublicProfile(companyId),
    queryOptions
  );
}